import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "./store";
import type { KycFeatureSettings } from "./UserSlice";
import type { Notifications } from "./NotificationsSlice";
import { useSelector } from "react-redux";

export { selectPermission, useHasPermission } from "../hooks/usePermissions";

export const selectAllNotifications = createSelector(
  (state: RootState) => state.globalNotifications.notificationList,
  (notifications): Notifications[] => notifications
);

export const getNotificationsByUserId = (
  userId: number
): ((_state: RootState) => Notifications[]) => {
  return createSelector(
    (state: RootState) => state.globalNotifications.notificationList,
    (notifications): Notifications[] =>
      notifications.filter((notification) =>
        notification.userIds.includes(userId)
      )
  );
};

export const getCurrentUserId = createSelector(
  (state: RootState): number => state.globalNotifications.currentUserId,
  Number
);

export const selectFeatureFlag = (
  state: RootState,
  featureKey: string
): boolean => {
  return state?.user?.kycFeatures?.some(
    (feature: KycFeatureSettings) => feature[featureKey] === "on"
  );
};

export const IsFeatureFlagEnabled = (flag: string): boolean => {
  return useSelector((state: RootState) => selectFeatureFlag(state, flag));
};

export const selectIsPermissionsLoaded = (state: RootState): boolean => {
  return state?.user?.isPermissionsLoaded ?? false;
};

export const useIsPermissionsLoaded = (): boolean => {
  return useSelector(selectIsPermissionsLoaded);
};
